"use strict";

module.exports = require("./_StatusBar.js");